import React from 'react';

const PublicLoading = () => {
    return (
        <div style={{
            position: 'fixed',
            inset: 0,
            zIndex: 99999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#ffffff',
        }}>
            <div style={{
                width: '40px',
                height: '40px',
                border: '3px solid #f2f4f7',
                borderTopColor: '#1E67E2',
                borderRadius: '50%',
                animation: 'publicLoadingSpin 0.8s linear infinite',
            }} />

            <style>{`
                @keyframes publicLoadingSpin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default PublicLoading;
